const data = [
  {
    id: 1,
    submissionno: "800058228983",
    dateCreated: "2024/01/10",
    submittedDate: "2024/01/15",
    rs: "Rs 1500000000.00",
    referFund: "Rs 1,500,000,000.00",
    reverseFund: "Rs 1,500,000,000.00",
    otherFunds: "Rs 1,500,000,000.00",
    grossSavings: "Rs 1,500,000,000.00",
    time: "10:00 AM",
    loanToken: 3000,
    otherLiability: 800,
    savingsLoss: "Profit",
    totalLiability: 7500,
    cashBalance: 30000,
    bankBalance: 50000,
    nmbBank: 15000,
    serviceBank: 10000,
    investmentSavings: 45000,
    regularSaving: 2000,
    optionalSavings: 3000,
    periodicSavings: 5000,
    totalAssets: 95000,
    cb1: 10000,
    bb1: 20000,
    nmbBank1: 8000,
    sunriseBank: 12000,
    investmentSavings1: 35000,
    status: "Draft",
  },
  {
    id: 2,
    submissionno: "800058228984",
    dateCreated: "2024/01/12",
    submittedDate: "2024/01/18",
    rs: "Rs 1500000000.00",
    referFund: "Rs 1500000000.00",
    reverseFund: "Rs 1500000000.00",
    otherFunds: "Rs 1500000000.00",
    grossSavings: "Rs 1,500,000,000.00",
    time: "10:00 AM",
    loanToken: 3200,
    otherLiability: 900,
    savingsLoss: "Loss",
    totalLiability: 7800,
    cashBalance: 32000,
    bankBalance: 52000,
    nmbBank: 16000,
    serviceBank: 11000,
    investmentSavings: 47000,
    regularSaving: 2200,
    optionalSavings: 3200,
    periodicSavings: 5200,
    totalAssets: 97000,
    // cb1: 12000,
    bb1: 22000,
    nmbBank1: 9000,
    sunriseBank: 14000,
    investmentSavings1: 37000,
    // Corrected from grossSavings1 to grossSavings
    status: "Initiated",
  },
  {
    id: 3,
    submissionno: "800058228985",
    dateCreated: "2024/01/10",
    submittedDate: "2024/01/15",
    reverseFund: "Rs 10,000,000,000",
    otherFunds: "Rs 1,500,000,000.00",
    grossSavings: "Rs 1,500,000,000.00",
    time: "10:00 AM",
    savingsLoss: "Profit",
    status: "Submitted",
    // Add more fields as needed
  },
  {
    id: 4,
    submissionno: "800058228985",
    dateCreated: "2024/01/10",
    submittedDate: "2024/01/15",
    reverseFund: "Rs 10,000,000,000",
    time: "10:00 AM",
    otherFunds: "Rs 500,000,000.00",
    grossSavings: "Rs 1500,,000,000.00",
    savingsLoss: "Profit",
    status: "Acknowledged",
    // Add more fields as needed
  },
  {
    id: 5,
    submissionno: "800058228985",
    dateCreated: "2024/01/10",
    submittedDate: "2024/01/15",
    reverseFund: "Rs 10,000,000,000",
    otherFunds: "Rs 500,000,000.00",
    grossSavings: "Rs 1,500,00,0000.00",
    time: "10:00 AM",
    savingsLoss: "Profit",
    status: "Approved",
    // Add more fields as needed
  },
  {
    id: 6,
    submissionno: "800058228985",
    dateCreated: "2024/01/10",
    submittedDate: "2024/01/15",
    reverseFund: "Rs 10,000,000,000",
    otherFunds: "Rs 500,000,000.00",
    grossSavings: "Rs 1,500,000,000.00",
    time: "10:00 AM",
    savingsLoss: "Profit",
    status: "Acknowledged",
    // Add more fields as needed
  },
  // Add more data as needed
];

export default data;
